import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const StandardToastContainer = styled(Box).attrs({
  horizontal: true,
  flow: 12,
  align: 'center',
})``;
